
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller/st-kilian",
      function () {
        return require("private-next-pages/seller/st-kilian.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller/st-kilian"])
      });
    }
  